import styled from 'styled-components';

/**
 * The label-and-switch line inside a toggle card.
 *
 * Its min-height matches the card's, and the card is given no vertical
 * padding, so the row fills the box and centres its own contents. Left to the
 * box's padding the 28px row sat 6px above centre - the block flow put it
 * under the top padding rather than in the middle of what was left.
 */
export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 70px;

  @media (max-width: 800px) {
    min-height: 60px;
  }
`;
